import { Injectable } from '@angular/core';

import { Observable, Subject, asyncScheduler, combineLatest, forkJoin, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { ApiService } from '@core/services/api/api.service';
import { ConfirmService } from '@core/services/confirm/confirm.service';
import { UtilsService } from '@core/services/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class AdditionalCardService {
  // trigger, запускаемый из заголовка page и читаемый в компоненте. Активирует выбор вложений в компоненте.
  chooseAttachments$ = new Subject<void>();

  constructor(
    private api: ApiService,
    private util: UtilsService,
    private confirmService: ConfirmService
  ) {}

  public getAdditionalCardConfirm(docId: string): Observable<any> {
    return this.confirmService.getConfirmData(docId);
  }

  openAdditionalCard(data?: any, mode?: boolean): Observable<any> {
    return this.api
      .post(
        `rest/personal/request/process/our/fl_request_open_addit_card${mode ? '?mode=' + mode : ''}`,
        data ? data : {}
      )
      .pipe(map((res: any) => (!data ? (res && res.docSettings ? this.util.getArray(res.docSettings) : []) : res)));
  }

  getAdditionalLists(list: 'branches' | 'products') {
    return this.api.get(`rest/personal/request/process/fl_request_open_addit_card/info/${list}`).pipe(
      map((res: any) => {
        if (res) {
          if (res.bankBranch) {
            return res.bankBranch;
          }

          if (res.accIdProducts) {
            return res.accIdProducts;
          }
        } else {
          return [];
        }
      })
    );
  }

  fetchCardOffices() {
    return this.api.get('public/json', {
      params: {
        service: 'atms',
        office_type: 1,
        office_service: 'Карты'
      }
    });
  }

  getAdditionalCardProducts(cardId: string) {
    return this.requestAdditionalCardProducts(cardId).pipe();
  }

  requestAdditionalCardProducts(cardId: string) {
    return this.api
      .get(`rest/personal/request/process/our/fl_request_open_addit_card/info/progcards?cardId=${cardId}`)
      .pipe(
        map((res: any) => {
          if (res && res.list) {
            return this.util.getArray(res.list);
          } else {
            return [];
          }
        })
      );
  }

  getAdditionalPrefill(data) {
    return this.api.post(`rest/personal/request/process/fl_request_open_addit_card/prefill`, data);
  }

  getAdditionalCardDocs() {
    return this.api
      .get(`rest/personal/request/process/fl_request_open_addit_card/info/ru_rko_identity_doc_type_taxes`)
      .pipe(
        map((res: any) => {
          if (res) {
            return this.util.getArray(res);
          } else {
            return [];
          }
        })
      );
  }

  getAdditionalCardData(id: string, type: 'another' | 'current'): Observable<any> {
    return combineLatest(
      this.openAdditionalCard(),
      this.getAdditionalLists('branches'),
      this.getAdditionalLists('products'),
      this.getAdditionalCardProducts(id),
      this.getAdditionalPrefill({ maincardId: id }),
      this.fetchCardOffices(),
      type === 'another' ? this.getAdditionalCardDocs() : of([], asyncScheduler)
    );
  }

  // взято из CorrespondenceService:
  uploadAttachments(docId: string, attachments: FileList | File[]): Observable<any> {
    if (!attachments || !attachments.length) {
      return of(true);
    }
    return forkJoin(Array.from(attachments).map((file) => this.uploadAttachment(docId, file)));
  }

  // CorrespondenceService
  private uploadAttachment(mailId: string, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', mailId);
    return this.api.post(`rest/personal/attachment`, formData);
  }
}
